import { Flex } from '@chakra-ui/react';
import { Avatar, Heading, TextLink, theme } from 'ui-components';
import authApi from '~/authApi';
import { FEATURE_FLAGS, USER_ROLES } from '~/constants';
import { routes } from '~/core/router';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { CreatorInfo } from '~/screens/ContentSharedScreen/ContentSharedScreen.types';

export interface CreatorHeaderSharedScreenProps {
  creator: CreatorInfo;
}

export function CreatorHeaderSharedScreen({
  creator,
}: CreatorHeaderSharedScreenProps) {
  const foamContentProfileLinkEnabled =
    useFeatureFlag(FEATURE_FLAGS.foamContentProfileLink) === 'enabled';

  const { roles } = authApi.user;
  const isCreator =
    roles.includes(USER_ROLES.creator) ||
    roles.includes(USER_ROLES.managed) ||
    roles.includes(USER_ROLES.echoCreator);

  return (
    <Flex padding="spacing-300" gap="spacing-100" alignItems="center">
      <Avatar
        src={creator.avatar}
        name={creator.fullName}
        alt={creator.fullName}
        size={'md'}
      />
      {foamContentProfileLinkEnabled && !isCreator ? (
        <TextLink
          href={routes.sharedProfileOverview(creator.slug || '')}
          size="xl"
          variant="primary"
          isBold
          _hover={{
            textDecoration: 'underline',
            textDecorationColor: theme.colors.secondary[500],
          }}
          trackId="foam-view-creator-from-content"
        >
          {creator.fullName}
        </TextLink>
      ) : (
        <Heading size="sm">{creator.fullName}</Heading>
      )}
    </Flex>
  );
}
